import { UIGameAnimationBase } from './UIGameAnimationBase.ts';
export class UIGameTimedAnimation extends UIGameAnimationBase {
    onGameTick(deltaTime, elapsedMS) {
        this.totalElapsedMS += elapsedMS;
        if (this.totalElapsedMS >= this.duration) {
            this.stop();
            return;
        }
        this.updateAnimation(deltaTime, elapsedMS);
    }
    constructor(duration){
        super(), this.totalElapsedMS = 0;
        this.duration = duration;
    }
}
